export default "__VITE_ASSET__VnQGapOf__"